import { render, staticRenderFns } from "./ExtraFieldNamesEdit.vue?vue&type=template&id=63af1508&scoped=true"
import script from "./ExtraFieldNamesEdit.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldNamesEdit.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldNamesEdit.vue?vue&type=style&index=0&id=63af1508&lang=css"
import style1 from "./ExtraFieldNamesEdit.vue?vue&type=style&index=1&id=63af1508&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af1508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63af1508')) {
      api.createRecord('63af1508', component.options)
    } else {
      api.reload('63af1508', component.options)
    }
    module.hot.accept("./ExtraFieldNamesEdit.vue?vue&type=template&id=63af1508&scoped=true", function () {
      api.rerender('63af1508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ExtraFieldNamesEdit.vue"
export default component.exports